/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Severitycontractorresponse2Inputs */

const en_severitycontractorresponse2 = /** @type {(inputs: Severitycontractorresponse2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contractor response`)
};

const pt_severitycontractorresponse2 = /** @type {(inputs: Severitycontractorresponse2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resposta do empreiteiro`)
};

/**
* | output |
* | --- |
* | "Contractor response" |
*
* @param {Severitycontractorresponse2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const severitycontractorresponse2 = /** @type {((inputs?: Severitycontractorresponse2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Severitycontractorresponse2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_severitycontractorresponse2(inputs)
	return pt_severitycontractorresponse2(inputs)
});
export { severitycontractorresponse2 as "severityContractorResponse" }